import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addNewCollection,
  getAllCollections,
} from "../../redux/apiCall/collectionCall.jsx";
import AdminFormLayout from "../components/AdminFormLayout";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ButtonComponent from "../../components/ButtonComponent.jsx";

const AddCollectionForm = () => {
  const collections = useSelector((state) => state.collection);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    collectionName: "",
    collabTitle: "",
    collectionDescription: "",
    collectionImage: "",
  });

  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.files
        ? event.target.files[0]
        : event.target.value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const data = new FormData();
    data.append("collectionName", formData.collectionName);
    data.append("collabTitle", formData.collabTitle);
    data.append("collectionDescription", formData.collectionDescription);
    data.append("collectionImage", formData.collectionImage);

    try {
      dispatch(addNewCollection(data)).then(() => {
        dispatch(getAllCollections());
      });
      setFormData({
        collectionName: "",
        collabTitle: "",
        collectionDescription: "",
        collectionImage: "",
      });
      // reset image
      event.target.elements["collectionImage"].value = "";
      toast.success("Collection added successfully!");
      navigate("/admin/admincollections");
    } catch (error) {
      console.error("Error adding new collection:", error.message);
      toast.error("Error adding Collection. Please try again.");
    }
  };

  return (
    <AdminFormLayout title="Add Collection" backTo="/admin/admincollections" backLabel="Back to Collections">
        <form onSubmit={handleSubmit}>
          <div className="admin-form-group">
            <label htmlFor="collectionName">Collection Name</label>
              <input
                className="form-control admin-all-forms-inputs"
                type="text"
                name="collectionName"
                id="collectionName"
                value={formData.collectionName}
                onChange={handleChange}
                required
              />
          </div>
          <div className="admin-form-group">
            <label htmlFor="collabTitle">Collaboration Title (page heading)</label>
              <input
                className="form-control admin-all-forms-inputs"
                type="text"
                name="collabTitle"
                id="collabTitle"
                value={formData.collabTitle}
                onChange={handleChange}
                placeholder="Leave blank to auto-generate from collection name"
                maxLength={200}
              />
          </div>
          <div className="admin-form-group">
            <label htmlFor="collectionDescription">Collection Description</label>
              <textarea
                className="form-control admin-all-forms-inputs"
                name="collectionDescription"
                id="collectionDescription"
                value={formData.collectionDescription}
                onChange={handleChange}
                required
                style={{ height: "200px" }}
                maxLength={1600}
              />
          </div>
          <div className="admin-form-group">
            <label htmlFor="collectionImage">Collection Image</label>
              <input
                className="form-control admin-all-forms-inputs"
                type="file"
                name="collectionImage"
                id="collectionImage"
                onChange={handleChange}
                required
              />
          </div>
          <ButtonComponent type="submit">Add Collection</ButtonComponent>
        </form>
    </AdminFormLayout>
  );
};

export default AddCollectionForm;
